import AbstractSitePageModel from './AbstractSitePageModel';
import doc                   from '@widesk-core/decorators/doc';
import { Translatable }      from '@widesk-core/decorators/translatable';
import { RenderNameProps }   from '@widesk-ui/mixins/ApiModelRenderName';
import appStore              from '@/stores/appStore';
import { computed }          from 'mobx';
import { getLocale }         from '@widesk-core/locale';

@doc.urnResource('site_page')
@doc.translatable({ title: true, content: true, excerpt: true, codeContent: true })
class SitePageModel extends AbstractSitePageModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${appStore.websiteEntertainment?.id}`;
	}

	static get urlPrefix() {
		return `/${getLocale()}/`;
	}

	getUrl(complete = false) {
		const path = SitePageModel.urlPrefix + this.slug;

		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	public getUrlByLang(lang: LanguageKey) {
		return `/${lang}/${this.slug}`;
	}

	get status() {
		return this.sitePageStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}

	public renderName(props?: RenderNameProps<this> & SitePageNameProps) {
		return super.renderName(props);
	}
}

interface SitePageModel
	extends Translatable<{ title: true, content: true, excerpt: true, codeContent: true }> {
}

export default SitePageModel;
